// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select-base-amount-dialog[data-v-70f2a74a] {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10px;
  height: 350px;
}
`, "",{"version":3,"sources":["webpack://./src/views/DesignBudgetSoftware/InitialSchemeEstimate/SelectBaseAmountDialog.vue","webpack://./SelectBaseAmountDialog.vue"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;EACA,aAAA;ACAF","sourcesContent":["\n.select-base-amount-dialog {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 10px;\n  height: 350px;\n}\n",".select-base-amount-dialog {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 10px;\n  height: 350px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
